import Layout from '@/layout';
var orderRouter = {
  path: '/servicePage',
  component: Layout,
  redirect: '/servicePage/index',
  name: 'ServicePage',
  alwaysShow: true,
  meta: {
    title: '客服管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/servicePage/index');
    },
    name: 'ServicePageIndex',
    meta: {
      title: '消息列表'
    }
  }]
};
export default orderRouter;